import { render, staticRenderFns } from "./RotatingCard.vue?vue&type=template&id=41a9972c&"
import script from "./RotatingCard.vue?vue&type=script&lang=js&"
export * from "./RotatingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports